import apiClient from '../ApiClient';

// Updated the function to accept pagination parameters
export const fetchUserServicesFeeds = async ({ userId, pageParam = 1 }: {userId: string, pageParam: number }): Promise<any> => {
  const res = await apiClient.get(`user-services-posts/${userId}`, {
    params: {
      page: pageParam,
    },
  });

  return {
    data: res.data?.data ?? [],
    totalPages: res.data?.pagination?.last_page ?? 0,
    totalItems: res.data?.pagination?.per_page ?? 0,
    currentPage: res.data?.pagination?.current_page ?? 0,
  };
};